<template>
    <div class="centerPage">
        <!--        点击事件,点到分类才从后端穿数据@tab-click="handleClick"-->
        <!--        value标签页默认值-->
        <el-tabs :value="activeName" class="tabs" @tab-click="handleClick">
            <!--            根据标签进行循环-->
            <el-tab-pane :label="obj.name" :name="obj.code" v-for="(obj, index) in group" :key="index">
                <div class="article" v-if="artList!=0">
                    <div class="articleList"
                         v-for="(item,ind) in artList"
                         :key="ind">
                        <div v-if="item.thumbnailPath" :style="'backgroundImage: url('+item.thumbnailPath+')'" class="img">
                            <span :state="item.approveStatus+'_'+item.status">{{item | articleStatusFmt}}</span>
                        </div>
                        <div v-else :style="{backgroundImage:'url('+require('../../assets/img/default_thumbnail_news.jpg')+')'}" class="img">
                            <span :state="item.approveStatus+'_'+item.status">{{item | articleStatusFmt}}</span>
                        </div>

                        <div class="content">
                            <h3>{{item.title}}
                            </h3>
                            <p>{{item.summary}}</p>
                        </div>
                        <div class="btn">
                            <el-button @click="cancelPublish(item)" v-if="item.status==1&&item.approveStatus==2">取消发布</el-button>
                            <el-button @click="editArt(item)" v-else>编辑</el-button>
                            <el-button class="delete" @click="del(item)">删除</el-button>
                        </div>
                    </div>
                </div>
                <div class="empty" v-else>
                    <img src="../../assets/img/no.png" alt="" width="200">
                    <p>这里什么都没有</p>
                </div>
                <el-pagination
                        :hide-on-single-page="true"
                        class="pagination"
                        background
                        prev-text="Prev"
                        next-text="Next"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-size="pageSize"
                        layout="prev, pager, next"
                        :total="total">
                </el-pagination>
            </el-tab-pane>
        </el-tabs>
        <el-button size="mini" class="addART" @click="addArt">新增文章</el-button>
    </div>
</template>

<script>
    import commonjs from "@/api/common";

    export default {
        name: "articles",
        data() {
            return {
                activeName: '',//当前标签
                currentPage: 1,// 当前页
                pageSize: 5,// 每页多少条
                artList: [],//文章列表数据
                total: 0,//该标签文章总数
                apiUrl: "",//文章列表的api
                group: [],
            }
        },
        mounted() {
            // 增加权限管理
            let permissions = [];
            let that = this;
            if(localStorage.getItem("permission")){
                permissions = JSON.parse(localStorage.getItem("permission"));
            }
            $(permissions).each((i,o)=>{
                if(o == 'doctor:article:research'){
                    that.group.push({name:'每日研究',code:'research',sort: 1});
                }else if(o == 'doctor:article:information'){
                    that.group.push({name:'新闻资讯',code:'information',sort: 2});
                }else if(o == 'doctor:article:science'){
                    that.group.push({name:'公益科普',code:'science',sort: 3});
                }
            });
            if(this.group.length !== 0){
                // 调整顺序
                that.group.sort((a, b) => a.sort - b.sort);
                let tabCode = this.group[0].code;
                this.apiUrl = commonjs.api.article[tabCode].pageById;//默认的获取文章列表的api
                this.activeName = tabCode;
            }
            this.getArticles();
        },
        inject: ['reload'],
        methods: {
            // 每页多少条
            handleSizeChange(val) {
                this.pageSize = val;
            },
            // 当前页  根据标签页分别执行传输
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getArticles();
            },
            //新建文章
            addArt() {
                let state = '0';
                if(this.activeName == 'information'){
                    state = '1';
                }else if(this.activeName == 'science'){
                    state = '2';
                }
                this.$router.push({name: 'articleEdit', query: {'state': Number(state), 'status': '0'}});
            },
            //编辑文章
            editArt(item) {
                let id = item.id;
                if(item.status == 2){
                    this.$message.error('违规内容无法操作!');
                    return;
                }

                let state = '0';
                if(this.activeName == 'information'){
                    state = '1';
                }else if(this.activeName == 'science'){
                    state = '2';
                }
                this.$router.push({name: 'articleEdit', query: {state: Number(state), id: id, status: '1'}})
            },
            //删除文章
            del(item) {
                let id = item.id;
                if(item.status == 2){
                    this.$message.error('违规内容无法操作!');
                    return;
                }
                let vm = this;
                let url = "";
                if (this.activeName == 'research') {
                    url = commonjs.api.article.research.delete;
                } else if (this.activeName == 'information') {
                    url = commonjs.api.article.information.delete;
                } else if (this.activeName == 'science') {
                    url = commonjs.api.article.science.delete;
                }
                this.$confirm(
                    '此操作将永久删除该文章,是否继续?',
                    '提示',
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$ajax.post(url.replace("{id}",id)).then(res=>{
                          if(res.data.status === 'success'){
                            this.$message.success('操作成功');
                            this.getArticles();
                          }else{
                            this.$message.error('操作失败');
                          }
                        });
                    })
            },
            //获取文章列表
            getArticles() {
                let that = this;
                this.$ajax
                    .get(this.apiUrl.replace("{currentPage}/{pageSize}", this.currentPage + "/" + this.pageSize))
                    .then(function (res) {
                      if (res.data.status === 'success') {
                        that.artList = res.data.rows;
                        that.total = res.data.total;
                      }
                    });
            },
            //点击标签页时,把分页currentPage归零
            handleClick(tab) {
                if (tab.name == "research") {
                    this.activeName = "research";
                    this.apiUrl = commonjs.api.article.research.pageById;
                } else if (tab.name == "information") {
                    this.activeName = "information";
                    this.apiUrl = commonjs.api.article.information.pageById;
                } else if (tab.name == "science") {
                    this.activeName = "science";
                    this.apiUrl = commonjs.api.article.science.pageById;
                }
                this.currentPage = 0;
                this.getArticles();
            },
            cancelPublish(item) {
                let id = item.id;
                let url = "";
                if (this.activeName == 'research') {
                    url = commonjs.api.article.research.cancel;
                } else if (this.activeName == 'information') {
                    url = commonjs.api.article.information.cancel;
                } else {
                    url = commonjs.api.article.science.cancel;
                }
                this.$confirm('此操作将取消发布该文章,是否继续?', '提示', {
                        confirmButtonText: '取消发布',
                        cancelButtonText: '不取消',
                        type: 'warning'
                }).then(() => {
                    this.$ajax.post(url.replace("{id}",id)).then(res=>{
                        if(res.data.status === 'success'){
                            this.$message.success("操作成功");
                            item.status = 0;
                            item.approveStatus = 0;
                        }else{
                            this.$message.error(res.data.message());
                        }
                    }).catch(err=>{
                        this.$message.error("操作失败");
                        console.error(err);
                    });
                }).catch(() => {
                    /*
                        this.$message({
                            type: 'info',
                            message: '不取消'
                        })
                    */
                })
            },//取消发布文章
        },
        filters:{
            articleStatusFmt(item){
                if(!item){
                    return "-";
                }
                if(item.approveStatus == 0 && item.status == 0){
                    return '草稿';
                }else if(item.approveStatus == 1 && item.status == 0){
                    return '审核中';
                }else if(item.approveStatus == 2 && item.status == 1){
                    return '审核通过';
                }else if(item.approveStatus == 3 && item.status == 0){
                    return '审核拒绝';
                }else if(item.approveStatus == 3 && item.status == 2){
                    return '违规封禁';
                }else {
                    return "-";
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../assets/css/banner.scss';

    .centerPage {
        position: relative;
    }

    .img {
        position: relative;

        span {
            position: absolute;
            top: 0;
            left: 0;
            width: 53px;
            height: 27px;
            border-radius: 0px 0px 13px 0px;
            font-size: 12px;
            color: #ffffff;
            font-weight: 400;
            display: flex;
            align-items: center;
            justify-content: center;
        }


        span[state='0_0']{background: #909399;}/*草稿*/
        span[state='1_0']{background: #567BFF;}/*提交*/
        span[state='2_1']{background: #67C23A;}/*审核通过*/
        span[state='3_0']{background: #E6A23C;}/*审核拒绝*/
        span[state='3_2']{background: #F56C6C;}/*封禁*/
    }
</style>
